m<template>
  <div>

    <v-container flex class="pt-0">
      <v-layout
        style="margin-bottom: 64px;"
        text-xs-center
        wrap
      >

        <template v-if="version === 'simple'" >
          <SimpleTab v-for="(box, i) in boxes" :key="'box-'+i" :box="box" />
        </template>
        <template v-else-if="version === 'overview'" >
          <OverviewTab v-for="(box, i) in boxes" :key="'box-'+i" :box="box" />
        </template>
        <template v-else-if="version === 'horizontal'" >
          <HorizontalTab  v-for="(box, i) in boxes" :key="'box-'+i" :box="box" />
        </template>
<template v-else-if="version === 'expand'" >
        <ExpandingTab v-for="(box, i) in boxes" :key="'box-'+i" :box="box" />
</template>

        <template v-else-if="version === 'vertical'" >
          <VerticalTab  v-for="(box, i) in boxes" :key="'box-'+i" :box="box" />
        </template>

      </v-layout>

    </v-container>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

import ExpandingTab from '../components/ExpandingTab'
import HorizontalTab from './HorizontalTab'
import VerticalTab from './VerticalTab'
import SimpleTab from './SimpleTab'
import OverviewTab from './OverviewTab'

export default {
  components: {
    SimpleTab,
    HorizontalTab,
    ExpandingTab,
    VerticalTab,
    OverviewTab
  },
  props: {
    boxes: {
      type: Array,
      required: true
    },
    simple: {
      type: String,
      required: false,
      default: 'false'
    },
    version: {
      type: String,
      required: false,
      default: 'horizontal'
    }
  },
  data () {
    return {
      tabs: 0,
      tabs2: 0,
      panel: 0,
      expand: null,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  computed: {
    ...mapGetters({
      tabVersion: 'version/tabVersion'
    })
  },
  methods: {
    ...mapActions({
      updateTabVersion: 'version/updateTabVersion'
    })
  }
}
</script>

<style>

</style>
